import React, {Component} from "react";
import CmModal from "../../../../../components/CmModal/CmModal";
import CmForm from "../../../../../components/CmForm/CmForm";
import {Form, Input} from "antd";
import {message} from "../../../utils/sysManagementUtils";
import {validateName} from "../../../../../utils";

const TextArea = Input.TextArea;
const FormItem = Form.Item;

export default class RoleEditModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: null
        };
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if (this.props.visible&&this.props.visible !== prevProps.visible) {
            this.setState({
                editData: this.initData(this.props.data || {})
            });
        }
    };

    render() {
        const {
            visible
        } = this.props;

        const {editData} = this.state;

        if (!editData) {
            return null;
        }

        const isCreate = !editData.id.value;
        const onDataChange = this.onDataChange;

        return (
            <CmModal
                title={isCreate ? "添加角色" : "角色信息"}
                visible={visible}
                handleCancel={this.handleCancel}
                handleOk={this.handleOk}
                okText={isCreate ? "确认" : "保存"}
                destroyOnClose={true}
            >
                <CmForm>
                    <FormItem
                        required={editData.roleName.required}
                        label={editData.roleName.label}
                    >
                        <Input
                            placeholder={editData.roleName.placeholder}
                            value={editData.roleName.value}
                            onChange={e => onDataChange({roleName: e.target.value})}
                        />
                    </FormItem>
                    <FormItem
                        required={editData.roleCode.required}
                        label={editData.roleCode.label}
                    >
                        <Input
                            placeholder={editData.roleCode.placeholder}
                            value={editData.roleCode.value}
                            onChange={e => onDataChange({roleCode: e.target.value})}
                            disabled={isCreate?false:true}
                        />
                    </FormItem>
                    <FormItem
                        required={editData.roleDesc.required}
                        label={editData.roleDesc.label}
                    >
                        <TextArea
                            placeholder={editData.roleDesc.placeholder}
                            rows={4}
                            value={editData.roleDesc.value}
                            onChange={e => onDataChange({roleDesc: e.target.value})}
                            onKeyUp={e => e.stopPropagation()}
                        />
                    </FormItem>
                </CmForm>
            </CmModal>
        );
    }

    onDataChange = data => {
        const editData = this.state.editData;
        Object.keys(data).forEach(key => {
            editData[key].value = data[key];
        });
        this.setState({});
    };

    handleOk = () => {
        const {editData} = this.state;
        const data = {};
        const editDataKeys = Object.keys(editData);
        for (let i = 0; i < editDataKeys.length; i++) {
            const key = editDataKeys[i];
            data[key] = editData[key].value;
            if (editData[key].check && !editData[key].check(editData[key].value)) {
                return;
            }
        }
        this.props.handleOk(data);
    };

    handleCancel = () => {
        this.props.handleCancel();
    };

    initData = (
        {
            id = "",
            roleName = "",
            roleCode = "",
            roleState = "1",
            menuCods = [],
            permissionCodes = [],
            roleDesc = ""
        } = {}
    ) => {
        const editData = {
            id: {
                value: id
            },
            roleName: {
                value: roleName,
                label: "角色名称",
                required: true,
                placeholder: "请输入角色名称",
                check: value => {
                    if (!value) {
                        message.error("角色名称不能为空");
                        return false;
                    }
                    if (!validateName(value, {min: 1, max: 50})) {
                        message.error("角色名称最多50个字符，可使用中文、数字、字母、下划线");
                        return false;
                    }
                    return true;
                }
            },
            roleCode: {
                value: roleCode,
                label: "角色编码",
                required: true,
                placeholder: "请输入角色编码",
                check: value => {
                    if (!value) {
                        message.error("角色编码不能为空");
                        return false;
                    }
                    if (!(/^[0-9a-zA-Z:_]{1,100}$/.test(value))) {
                        message.error("角色编码只可填写字母、数字、下划线及冒号，限制输入100个字符");
                        return false;
                    }
                    return true;
                }
            },
            roleState: {
                value: roleState,
                label: "状态",
                required: true
            },
            menuCods: {
                value: menuCods,
                label: "菜单集合"
            },
            permissionCodes: {
                value: permissionCodes,
                label: "权限列表"

            },
            roleDesc: {
                value: roleDesc,
                label: "描述",
                placeholder: "请输入描述信息",
            }
        };
        return editData;
    };
}

